var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { components } from 'react-select';
var MultiValueContainer = function (props) {
    var getValue = props.getValue, children = props.children;
    var selectProps = props.selectProps;
    var value = getValue();
    var valueLength = value.length;
    var isShowSelectedString = !!valueLength && !selectProps.menuIsOpen;
    return (_jsxs(Container, __assign({}, props, { children: [isShowSelectedString && (_jsx(MultiValueText, { children: valueLength === 1
                    ? value[0].label
                    : valueLength + " " + ((selectProps === null || selectProps === void 0 ? void 0 : selectProps.selectedLabel) ? selectProps.selectedLabel : 'Selected') }, void 0)), children] }), void 0));
};
export default MultiValueContainer;
var Container = styled(components.ValueContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var classNamePrefix = _a.selectProps.classNamePrefix;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", "__multi-value {\n      display: none;\n    }\n  "], ["\n    .", "__multi-value {\n      display: none;\n    }\n  "])), classNamePrefix);
});
var MultiValueText = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
